<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <FCCopy :h2="this.h2" :h3="this.h3">
      <template v-slot:copy>
        <strong>The best views in the house outside, an upscale all-inclusive lounge experience inside. The Pitch View Club boasts a breathtaking view of the pitch from an all glass exterior, as well as a one of a kind outdoor deck for viewing pleasure.</strong>
        <p class="map">
          <img
            src="~@/assets/maps/map-pitchviewclub.png"
            alt
            data-aos="zoom-in-up"
            data-aos-duration="250"
            data-aos-easing="ease-out-cubic"
          />
        </p>
      </template>
    </FCCopy>
  </div>
</template>

<script>
import FCCopy from "@/components/patterns/FCCopy";
export default {
  components: {
    FCCopy
  },
  mounted() {
    const ref = this.$store.state.menu.pitchView.ref;
    const index = this.$store.state.menu.menuItems.map(e => e.ref).indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.pitchView.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.pitchView.nav;
    this.onScroll();
  },
  data() {
    return {
      h2: "Pitch View Club",
      h3: "Intro"
    };
  }
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-pitch-intro.jpg");
  background-size: cover;
  background-position: center;
}
</style>